import Api from './Api'

class SellerService {
    static getShopInfo (code) {
        return Api().get('/seller?code=' + code);
    }  
}

export default SellerService;